import script from "./LocationCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./LocationCard.vue?vue&type=script&setup=true&lang=ts"

import "./LocationCard.vue?vue&type=style&index=0&id=454fa8ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-454fa8ba"]])

export default __exports__